import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Services.css";
import SEO from "../SEO";
export default function Services() {
  React.useEffect(() => {
    AOS.init({ once: true, duration: 800 });
  }, []);

  const services = [
    {
      title: "Custom Software Development",
      desc: "Custom business software solutions including ERP, POS, inventory and management systems built with .NET and modern technologies.",
      icon: "💻",
      features: [
        "ERP Systems",
        "Business Automation",
        "Scalable Architecture",
        "Secure & Tested Code",
      ],
    },
    {
      title: "POS & ERP Systems",
      desc: "Advanced POS systems and ERP software for inventory management, billing, accounting and multi-branch businesses.",
      icon: "🛒",
      features: [
        "Inventory Management",
        "Point of Sale (POS)",
        "Accounts & Reporting",
        "Multi-store Support",
      ],
    },
    {
      title: "Web Development",
      desc: "Professional business websites and web applications using React JS, .NET and modern frameworks.",
      icon: "🌐",
      features: [
        "React JS Development",
        "Responsive Design",
        "SEO Optimized",
        "High Performance",
      ],
    },
    {
      title: "E-Commerce Solutions",
      desc: "Complete e-commerce websites for online stores with payment integration and high conversion design.",
      icon: "🛍️",
      features: [
        "Online Store Setup",
        "Payment Integration",
        "Product Management",
        "Mobile Friendly",
      ],
    },
    {
      title: "Mobile App Development",
      desc: "Android & iOS mobile apps for businesses with modern UI and smooth performance.",
      icon: "📱",
      features: [
        "Android & iOS Apps",
        "Cross-Platform",
        "Fast Performance",
        "User-Friendly UI",
      ],
    },
    {
      title: "Cloud & DevOps",
      desc: "Cloud deployment, APIs, CI/CD pipelines and scalable infrastructure using Azure and AWS.",
      icon: "☁️",
      features: [
        "Azure & AWS Setup",
        "CI/CD Pipelines",
        "API Development",
        "Cloud Optimization",
      ],
    },
    {
      title: "Accounting Software",
      desc: "Custom accounting and financial management software for tracking expenses, sales and reports.",
      icon: "🧾",
      features: [
        "Expense Tracking",
        "Financial Reports",
        "Profit & Loss",
        "Business Insights",
      ],
    },
    {
      title: "AI & Automation",
      desc: "AI-powered chatbots, automation tools and intelligent business solutions.",
      icon: "🤖",
      features: [
        "AI Chatbots",
        "Automation Tools",
        "Data Analysis",
        "Smart Workflows",
      ],
    },
  ];
  return (
    <>
      <SEO
        title="Web Development & Software Services in Pakistan | MZR Software"
        description="We provide ERP software, POS systems, web development, React JS applications, e-commerce and custom software solutions for businesses in Pakistan."
        url="/web-development"
      />
      <section className="services-section">
        <div className="container">
          <div className="section-header text-center mb-5">
            <h1 className="section-title" data-aos="fade-up">
              Web Development & Software Services in Pakistan
            </h1>
            <p
              className="section-subtitle"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              We build ERP systems, POS software, web applications, e-commerce
              stores and custom business solutions using modern technologies.
            </p>
          </div>

          <div className="services-grid">
            {services.map((service, index) => (
              <div
                key={index}
                className="service-card"
                data-aos="flip-left"
                data-aos-delay={index * 50}
              >
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
                <div className="service-features">
                  {service.features.map((feature, i) => (
                    <span key={i} className="feature-tag">
                      ✓ {feature}
                    </span>
                  ))}
                </div>
                <a
                  href={
                    service.title.includes("POS")
                      ? "/pos-system"
                      : service.title.includes("ERP")
                        ? "/erp-software"
                        : service.title.includes("Web")
                          ? "/web-application"
                          : "#contact"
                  }
                  className="service-link"
                >
                  Learn More →
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
      <div className="text-center text-white mt-5">
        <h2>Best Software & Web Development Company in Pakistan</h2>
        <p style={{ maxWidth: "800px", margin: "0 auto" }}>
          MZR Software provides complete business solutions including ERP
          systems, POS software, web development, e-commerce platforms and
          custom software applications. We help businesses automate operations
          and grow faster with modern technology.
        </p>
      </div>
      <div className="text-center mt-5">
        <h2>Start Your Software Project Today</h2>
        <p>Let’s build your ERP, POS or web application.</p>

        <a
          href="https://wa.me/923351206586?text=Hi%20I%20need%20software%20solution"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
        >
          🚀 Get Free Consultation
        </a>
      </div>
    </>
  );
}
